if (!customElements.get('selling-plans')) {
  customElements.define(
    'selling-plans',
    class SellingPlans extends HTMLElement {
      constructor() {
        super();
        this.updateSellingPlanOptions = this.updateSellingPlanOptions.bind(this);
      }

      connectedCallback() {
        this.addEventListener('change', this.updateSellingPlanOptions);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.updateSellingPlanOptions);
      }

      updateSellingPlanOptions(event) {
        if (this.sellingPlanInput.contains(event.target)) return;
        const input = event.target;
        const { price, compare } = input.dataset;
        this.sellingPlanInput.value = input.value;
        this.priceOnSale.textContent = price;
        this.priceOnCompare.textContent = compare;
      }

      get priceOnSale() {
        return this.querySelector('.price-on--sale');
      }

      get priceOnCompare() {
        return this.querySelector('.price-on--compare>s');
      }

      get sellingPlanInput() {
        return this.querySelector('input[name="selling_plan"]');
      }

      get sellingOptions() {
        return this.querySelectorAll('input[name="SellingPlanSelect"]');
      }
    }
  )
}